export const SOCKET_URL = process.env.NEXT_PUBLIC_WSS_URL;
